import { InjectionToken } from '@angular/core';

export const CMS_DATA = new InjectionToken(
  'Token representing the cmsData from ActivatedRoute.data stream'
);
